import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Unit I (Manufacturing & Registered Office)',
      details: [
        'NH-6 Bypass Road, Chakarkend Chowk',
        'Bargarh - 768028, Odisha, India',
        'Covered area of 1,00,000 sq. ft. (approximately)'
      ],
      color: '#ef4444'
    },
    {
      icon: 'fas fa-phone',
      title: 'Sales & Business Inquiry',
      details: [
        '+91 9348335684',
        '+91 7008306474'
      ],
      color: '#10b981'
    },
    {
      icon: 'fas fa-envelope',
      title: 'Investor & Media Relations',
      details: [
        'investor@maharajapolyfab.com',
        'maharajapolyfabpvtltd@gmail.com'
      ],
      color: '#3b82f6'
    },
    {
      icon: 'fas fa-users',
      title: 'Human Resources',
      details: [
        'Total Workforce of 170+ Permanent Employees',
        '(as of Sept 01, 2025)'
      ],
      color: '#f59e0b'
    }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Get in Touch</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-intro">
              <p>
                Ready to discuss your packaging needs? Our expert team is here to help you 
                find the perfect solution for your business requirements.
              </p>
            </div>
            
            <div className="info-grid">
              {contactInfo.map((info, index) => (
                <div key={index} className="info-card">
                  <div className="card-glow" style={{ backgroundColor: `${info.color}15` }}></div>
                  <div className="info-icon" style={{ backgroundColor: info.color }}>
                    <i className={info.icon}></i>
                  </div>
                  <div className="info-content">
                    <h4>{info.title}</h4>
                    <ul className="info-details">
                      {info.details.map((detail, idx) => (
                        <li key={idx}>
                          <i className="fas fa-check-circle"></i>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send Us a Message</h3>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Enter your company name"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="quote">Request Quote</option>
                  <option value="product">Product Information</option>
                  <option value="support">Technical Support</option>
                  <option value="partnership">Partnership</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell us about your requirements..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                <i className="fas fa-paper-plane"></i>
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="map-section">
          <div className="map-container">
            <div className="map-header">
              <h3>Our Manufacturing Facility</h3>
              <p>NH-6 Bypass Road, Chakarkend Chowk, Bargarh - 768028, Odisha, India</p>
            </div>
            <div className="map-embed">
              <iframe
                src="https://www.google.com/maps?q=MAHARAJA+POLYFAB+PVT+LTD,+NH-6+Bypass+Road,+Chakarkend+Chowk,+Bargarh,+Odisha,+India&output=embed"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Maharaja Polyfab Location"
              ></iframe>
            </div>
            <div className="map-footer">
              <a href="https://www.google.com/maps/place/MAHARAJA+POLYFAB+PVT+LTD/@21.3209727,83.5137109,17z/data=!4m6!3m5!1s0x3a26b5e41ce1a05f:0x990203e13b66ba1!8m2!3d21.3209974!4d83.513545!16s%2Fg%2F11rty7rvrw?entry=ttu&g_ep=EgoyMDI1MTEwMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                <i className="fas fa-external-link-alt"></i>
                View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
